import { render } from "./App.vue?vue&type=template&id=f45822e8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/Dashboard_HV/Dashboard_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__